module.exports = __webpack_public_path__ + "img/popup-game-sucai.4f094de2.png";